import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import DeleteMeEmail from './DeleteMeEmail';

const DeleteMeReason = (props) => {
  const {
    reasonQuestion,
    onReasonChange,
    selectedReason,
    emailFieldName,
    onEmailChange,
    email,
    emailError,
  } = props;

  const reasonQuestionId = get(reasonQuestion, '_id', '');
  if (!reasonQuestionId) {
    return (null);
  }

  const reasonOptions = [];
  Object.keys(reasonQuestion.answers).forEach((key) => {
    const reasonOptionTitle = get(reasonQuestion, `answers.${key}`, '');
    reasonOptions.push(
      <div key={key} className="form-group form-radio">
        <label>
          <input
            type="radio"
            name={`answers[${reasonQuestionId}][]`}
            value={key}
            title={reasonOptionTitle}
            onChange={onReasonChange}
            checked={key === selectedReason}
          />
          {reasonOptionTitle}
        </label>
      </div>,
    );

    if (key === '-5' && selectedReason === '-5') {
      reasonOptions.push(
        <DeleteMeEmail
          key="email"
          name={emailFieldName}
          value={email}
          error={emailError}
          onChange={onEmailChange}
        />,
      );
    }
  });

  return (
    <div className="form-group g-b g-b--1of1 mbm">
      <div className="form-title mbs">
        {get(reasonQuestion, 'title', '')}
      </div>
      {reasonOptions}
    </div>
  );
};

DeleteMeReason.propTypes = {
  reasonQuestion: PropTypes.instanceOf(Object),
  onReasonChange: PropTypes.func.isRequired,
  selectedReason: PropTypes.string,
  emailFieldName: PropTypes.string,
  onEmailChange: PropTypes.func.isRequired,
  email: PropTypes.string,
  emailError: PropTypes.string,
};

DeleteMeReason.defaultProps = {
  reasonQuestion: {},
  selectedReason: '',
  emailFieldName: '',
  email: '',
  emailError: '',
};

export default DeleteMeReason;
